import { FC, ReactNode } from 'react';
import { cn } from '../../../../../utilities/cn';

const FormRow: FC<{
  label: string;
  children: ReactNode;
  layout?: 'inline' | 'stacked';
  className?: string;
  contentClassName?: string;
}> = ({ label, children, layout = 'inline', className, contentClassName }) => {
  if (layout === 'stacked') {
    return (
      <div className={cn('flex w-full flex-col gap-1', className)}>
        <label className="shrink-0 text-xs font-medium text-gray-600">{label}</label>
        <div className={cn('w-full min-w-0', contentClassName)}>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'grid gap-1.5 sm:grid-cols-[minmax(7.5rem,9rem)_1fr] sm:items-start sm:gap-4',
        className,
      )}
    >
      <span className="pt-2 text-xs font-medium text-gray-600">{label}</span>
      <div className={cn('min-w-0', contentClassName)}>{children}</div>
    </div>
  );
};

export default FormRow;
